module.exports = __webpack_public_path__ + "images/cd1f377a86b730961bf51406c2996676.png";